import {Dialog} from "@material-ui/core";
import React, {useState} from "react";
import {DeleteIcon} from "../banners/advertisersComponent";
import AddBannerComponent from "../addBanner";
import AddCategoryComponent from "../addCategory";
import AddProductComponent from "../addProduct/addProduct";
import CustomInput from "../../common/components/CustomInput";
import Utility from "../../utility";
import userService from "../../services/user";
import {Heading, InputColumn, InputRow} from "../../common/atoms/styles";
import {MainContainer} from "../plans/styles";
import Modal from "../../common/atoms/modal";
import AddCategoryParentComponent from "../addCategoryParent";

const UserDetailComponent = (props) => {
    const {data, refreshList, closeDialog} = props
    const updateUser = async (userId, isInactive) => {
        let [err, res] = await Utility.parseResponse(
            userService.updateUser({
                userId: userId,
                isInactive: isInactive,
            }, userId),
        );
        refreshList();
        closeDialog();
    }
    return (
        <MainContainer>
            <Heading>{`User Details`}</Heading>
            <InputRow>
                <InputColumn>
                    <span>UserId</span>
                    <span>Name</span>
                    <span>Shop Name</span>
                    <span>Phone Number</span>
                    <span>Added On</span>
                    <span>Active</span>
                </InputColumn>
                <InputColumn>
                    <span>{data._id}</span>
                    <span>{data.name}</span>
                    <span>{data.shopName || '-'}</span>
                    <span>{data.phone}</span>
                    <span> {new Date(data.addedOn).toLocaleDateString()}</span>
                    <CustomInput
                        type="checkbox"
                        checked={!data.isInactive}
                        onChange={() => updateUser(data._id, !data.isInactive)}
                    />
                </InputColumn>
            </InputRow>
        </MainContainer>)
}
const EditDialogComponent = (props) => {
    const {entityName, data, refreshList} = props
    const [isOpen, setOpen] = useState(false)

    return (
        <>
            <DeleteIcon src="/images/edit.png" onClick={() => setOpen(true)}/>
            <Modal
                fullWidth={true}
                isVisible={isOpen}
                onClose={() => setOpen(false)}
            >
                {entityName === 'banner' &&
                    <AddBannerComponent isToUpdate={true} data={data} closeDialog={() => setOpen(false)}/>}
                {entityName === 'category' &&
                    <AddCategoryComponent isToUpdate={true} data={data} closeDialog={() => setOpen(false)}/>}
                {entityName === 'parent-category' &&
                    <AddCategoryParentComponent isToUpdate={true} data={data} closeDialog={() => setOpen(false)}/>}
                {entityName === 'item' &&
                    <AddProductComponent isToUpdate={true} data={data} closeDialog={() => setOpen(false)}
                                         refreshList={refreshList}/>}
                {entityName === 'user' &&
                    <UserDetailComponent isToUpdate={true} data={data} closeDialog={() => setOpen(false)}
                                         refreshList={refreshList}/>}
            </Modal>
        </>
    )

}

export default EditDialogComponent
